import React from "react";
import {
  Box,
  Container,
  Stack,
  Heading,
  Text,
  SimpleGrid,
  Icon,
} from "@chakra-ui/react";
import { FaComments, FaPhone, FaVideo, FaUsers } from "react-icons/fa";
import Header from "./Header";
import Footer from "./Footer";

function FeaturesPage() {
  return (
    <Box>
      <Header />
      <Box as="section" py="20" bg="gray.50">
        <Container maxW="container.lg">
          <Stack spacing="6" textAlign="center" mb="12">
            <Heading>Features</Heading>
            <Text fontSize="lg">
              Experience a range of powerful features designed to keep you
              connected.
            </Text>
          </Stack>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing="10">
            {/* Instant Private Chat */}
            <Box bg="white" p="6" borderRadius="md" boxShadow="md">
              <Stack spacing="4" align="center">
                <Icon as={FaComments} w={10} h={10} color="teal.500" />
                <Heading size="md">Instant Private Chat</Heading>
                <Text textAlign="center">
                  Enjoy quick, secure, and private text messaging anytime,
                  anywhere.
                </Text>
              </Stack>
            </Box>
            {/* Audio Call */}
            <Box bg="white" p="6" borderRadius="md" boxShadow="md">
              <Stack spacing="4" align="center">
                <Icon as={FaPhone} w={10} h={10} color="teal.500" />
                <Heading size="md">Audio Call</Heading>
                <Text textAlign="center">
                  Make high-quality voice calls with crystal-clear audio.
                </Text>
              </Stack>
            </Box>
            {/* Video Call */}
            <Box bg="white" p="6" borderRadius="md" boxShadow="md">
              <Stack spacing="4" align="center">
                <Icon as={FaVideo} w={10} h={10} color="teal.500" />
                <Heading size="md">Video Call</Heading>
                <Text textAlign="center">
                  Connect face-to-face with high-definition video calls.
                </Text>
              </Stack>
            </Box>
            {/* Group Calls */}
            <Box bg="white" p="6" borderRadius="md" boxShadow="md">
              <Stack spacing="4" align="center">
                <Icon as={FaUsers} w={10} h={10} color="teal.500" />
                <Heading size="md">Group Calls</Heading>
                <Text textAlign="center">
                  Hold group calls with multiple participants for seamless
                  collaboration.
                </Text>
              </Stack>
            </Box>
          </SimpleGrid>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}

export default FeaturesPage;
